export function openDatabase() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('InstancesDB', 1);
        console.log('Opening IndexedDB:', request);

        request.onupgradeneeded = (event) => {
            console.log('onupgradeneeded triggered');
            const db = event.target.result;
            if (!db.objectStoreNames.contains('instances')) {
                console.log('Creating object store: instances');
                db.createObjectStore('instances', { keyPath: 'SeriesInstanceUID' });
            }
        };

        request.onsuccess = (event) => {
            console.log('Database opened successfully');
            const db = event.target.result;
            resolve(db); // Resolve the promise with the database instance
        };

        request.onerror = (event) => {
            console.error('Error opening IndexedDB:', event.target.error);
            reject(event.target.error); // Reject the promise with the error
        };

        request.onblocked = () => {
            console.error('IndexedDB open request is blocked. Close other connections.');
            reject(new Error('IndexedDB open request is blocked.'));
        };
    });
}

export async function saveInstance(instance) {
    const db = await openDatabase();
    const transaction = db.transaction('instances', 'readwrite');
    const store = transaction.objectStore('instances');
    store.put(instance);
    return transaction.complete;
}

export async function getInstance(seriesInstanceUID) {
    const db = await openDatabase();
    const transaction = db.transaction('instances', 'readonly');
    const store = transaction.objectStore('instances');
    return new Promise((resolve, reject) => {
        const request = store.get(seriesInstanceUID);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

export async function getAllInstances() {
    const db = await openDatabase();
    const transaction = db.transaction('instances', 'readonly');
    const store = transaction.objectStore('instances');
    return new Promise((resolve, reject) => {
        const request = store.getAll();
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

export async function getAllInstanceIds() {
    const db = await openDatabase();
    const transaction = db.transaction('instances', 'readonly');
    const store = transaction.objectStore('instances');
    return new Promise((resolve, reject) => {
        const request = store.getAllKeys();
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

export async function deleteInstance(seriesInstanceUID) {
    const db = await openDatabase();
    const transaction = db.transaction('instances', 'readwrite');
    const store = transaction.objectStore('instances');
    store.delete(seriesInstanceUID);
    return transaction.complete;
}